import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import Button, { ButtonSizes, ButtonThemes } from "ui-components/button/button";
import TimestampDisplay from "ui-components/timestamp-display/timestampDisplay";
import { DataTableColumnOption } from "ui-components/data-table/dataTableTypes";
import { DockTag } from "app/data/dock-scan/models";

export interface DockTagRow extends DockTag {
  employeeCount: number;
}

const columnHelper = createColumnHelper<DockTagRow>();

export const DOCK_TAGS_COLUMN_OPTIONS: DataTableColumnOption[] = [
  { id: "name", label: "Name" },
  { id: "employeeCount", label: "Employees" },
  { id: "createdAt", label: "Created" },
  { id: "updatedAt", label: "Updated" },
  { id: "actions", label: "Actions" },
];

export function getDockTagsColumns(options: {
  deleteConfirmId: string | null;
  isDeleting: boolean;
  onRequestDelete: (tagId: string) => void;
  onConfirmDelete: (tagId: string) => void;
  onCancelDelete: () => void;
}) {
  return [
    columnHelper.accessor("name", {
      id: "name",
      header: "Name",
      cell: (props) => <strong>{props.getValue()}</strong>,
      size: 200,
      minSize: 160,
    }),
    columnHelper.accessor("employeeCount", {
      id: "employeeCount",
      header: "Employees",
      cell: (props) => props.getValue(),
      size: 100,
      minSize: 90,
    }),
    columnHelper.accessor("createdAt", {
      id: "createdAt",
      header: "Created",
      cell: (props) => <TimestampDisplay value={props.getValue()} format="local" />,
      size: 140,
      minSize: 120,
    }),
    columnHelper.accessor("updatedAt", {
      id: "updatedAt",
      header: "Updated",
      cell: (props) => <TimestampDisplay value={props.getValue()} format="relative" />,
      size: 120,
      minSize: 110,
    }),
    columnHelper.display({
      id: "actions",
      header: "Actions",
      cell: (props) => {
        const tag = props.row.original;
        if (options.deleteConfirmId === tag.id) {
          return (
            <div className="dock-users__tag-delete-confirm">
              <span>Remove tag from all employees?</span>
              <Button
                theme={ButtonThemes.red}
                size={ButtonSizes.small}
                onClick={() => options.onConfirmDelete(tag.id)}
                disabled={options.isDeleting}
              >
                Delete
              </Button>
              <Button
                theme={ButtonThemes.gray}
                size={ButtonSizes.small}
                onClick={options.onCancelDelete}
              >
                Cancel
              </Button>
            </div>
          );
        }
        return (
          <Button
            theme={ButtonThemes.gray}
            size={ButtonSizes.small}
            onClick={() => options.onRequestDelete(tag.id)}
          >
            Delete
          </Button>
        );
      },
      size: 280,
      minSize: 200,
    }),
  ];
}
